// ✅ New component
import { set } from "lodash";
import React, { useState, useEffect } from "react";

const TableConditionRenderer = ({
  row,
  index,
  conditionsData,
  onTableChange,
  isEditing,
  isReadOnly,
  condFields,
  setCondFields,
  setFormErrors,
  getCondTableData
}: {

  row: {
    item: string;
    tableItems: { tableVal: string; tableHeading: string; tableType: string }[]
  };
  index: number;
  conditionsData: any[];
  onTableChange: (index: number, data: any) => void;
  isEditing?: boolean;
  isReadOnly?: boolean;
  condFields?: any;
  setCondFields?: any;
  setFormErrors?: any;
  getCondTableData?: any;
}) => {
  const [tableData, setTableData] = useState(() => {
    const obj: Record<string, any> = {};
    row.tableItems.forEach((t) => {
      obj[t?.tableVal] = conditionsData[index][t?.tableVal] || "";
    });
    return obj;
  });

  // Sync with incoming props (e.g., after auto-fill)
  useEffect(() => {
    const obj: Record<string, any> = {};
    row.tableItems.forEach((t) => {
      obj[t.tableVal] = conditionsData[index]?.[t.tableVal] ?? "";
    });
    setTableData(obj);
    
    getCondTableData(obj)
  }, [conditionsData, index, row.tableItems]);

  const handleChange = (field: string, value: any) => {
    const updated = { ...tableData, [field]: value };
    setTableData(updated);
    onTableChange(index, updated); // sync to parent
    if (field && Object.keys(condFields).includes(field)) {
      setCondFields((prev: any) => ({
        ...prev,
        [field]: value
      }));
    }

    setFormErrors((prevErrors: any) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[field];
      return updatedErrors;
    });
  };

  return (
    <div
      style={isEditing ? {
        border: '1px solid #d3d3d3',
        padding: '10px',
        borderRadius: '5px',
        outline: 'none'
      } : {}}
    >
      {/* Split the text by @table@ and render with table in between */}
      {row.item.split('@table@').map((textPart, index) => (
        <div key={index}>
          {/* Render the text part - make editable if isEditing */}
          <div
            className="mb-3"
            contentEditable={isEditing}
            suppressContentEditableWarning={true}
            dangerouslySetInnerHTML={{ __html: textPart }}
            onBlur={(e) => {
              if (isEditing) {
                const parts = row.item.split('@table@');
                parts[index] = e.currentTarget.innerHTML; // index here is from map
                const updatedItem = parts.join('@table@');
                onTableChange(index, { item: updatedItem }); // Use parent's index prop
              }
            }}
          />

          {/* Render the table after the first text part */}
          {index === 0 && (
            <div className="w-100 overflow-hidden border bg-white border-secondary rounded mb-3">
              <div
                className="d-flex w-100 rounded-top border-bottom border-secondary"
                style={{ backgroundColor: "#CCE3FF" }}
              >
                {row.tableItems.map((t) => (
                  <h6
                    key={t.tableVal}
                    className="col p-2 justify-content-center d-flex align-items-center border-secondary border-end"
                  >
                    {t.tableHeading}
                  </h6>
                ))}
              </div>
              <div className="d-flex">
                {row.tableItems.map((t) => (
                  <div
                    key={t.tableVal}
                    className="col p-2 justify-content-center d-flex align-items-center border-secondary border-end"
                  >
                    <input
                      type={t.tableType}
                      name={t.tableVal}
                      className="form-control"
                      value={tableData[t.tableVal]}
                      placeholder={`Enter ${t.tableHeading}`}
                      onChange={(e) => handleChange(t.tableVal, e.target.value)}
                      disabled={isReadOnly}
                      style={isReadOnly ? { cursor: "not-allowed", backgroundColor: "#f5f5f5" } : {}}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default TableConditionRenderer;
